<template>
  <div class="home">
    <section class="section">
    <div class="container">
      <h2 class="subtitle is-5 has-text-centered">
        Edit the Meal
      </h2>
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">

            <div class="field">
              <label class="label">When did you eat?</label>
              <div class="control">
                <Datetime v-model="eatingTime" input-class="input is-medium" type="datetime"></Datetime>
              </div>
            </div>
            <div class="field">
              <label class="label">How hungry were you BEFORE eating? 1=starving 10=stuffed</label>
              <div class="control">
                  <div class="buttons ">
                    <button v-bind:class="{'is-primary': hungerBefore === 1}" @click.prevent="hungerBefore=1"  class="button">1</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 2}" @click.prevent="hungerBefore=2"  class="button">2</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 3}" @click.prevent="hungerBefore=3"  class="button">3</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 4}" @click.prevent="hungerBefore=4"  class="button">4</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 5}" @click.prevent="hungerBefore=5"  class="button">5</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 6}" @click.prevent="hungerBefore=6"  class="button">6</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 7}" @click.prevent="hungerBefore=7"  class="button">7</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 8}" @click.prevent="hungerBefore=8"  class="button">8</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 9}" @click.prevent="hungerBefore=9"  class="button">9</button>
                    <button v-bind:class="{'is-primary': hungerBefore === 10}" @click.prevent="hungerBefore=10"  class="button">10</button>
                  </div>
              </div>
            </div>
            <div class="field">
              <label class="label">How hungry were you AFTER eating? 1=starving 10=stuffed</label>
              <div class="control">
                  <div class="buttons">
                    <button v-bind:class="{'is-primary': hungerAfter === 1}" @click.prevent="hungerAfter=1"  class="button">1</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 2}" @click.prevent="hungerAfter=2"  class="button">2</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 3}" @click.prevent="hungerAfter=3"  class="button">3</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 4}" @click.prevent="hungerAfter=4"  class="button">4</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 5}" @click.prevent="hungerAfter=5"  class="button">5</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 6}" @click.prevent="hungerAfter=6"  class="button">6</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 7}" @click.prevent="hungerAfter=7"  class="button">7</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 8}" @click.prevent="hungerAfter=8"  class="button">8</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 9}" @click.prevent="hungerAfter=9"  class="button">9</button>
                    <button v-bind:class="{'is-primary': hungerAfter === 10}" @click.prevent="hungerAfter=10"  class="button">10</button>
                  </div>
              </div>
            </div>

            <div class="field">
              <label class="label">What did you eat?</label>
              <div class="control">
                <textarea v-model="whatyouate" class="textarea is-medium"></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">What did you feel before, during and after eating?</label>
              <div class="control">
                <textarea v-model="feelings" class="textarea is-medium" ></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">Any other thoughts and feelings?</label>
              <div class="control">
                <textarea v-model="notes" class="textarea is-medium" ></textarea>
              </div>
            </div>
            <div class="field is-grouped">
              <div class="control">
                <button @click.prevent="saveMeal" :disabled="!saveBtnEnabled" v-bind:class="{'is-loading': saving}" class="button is-medium is-primary">Save Meal</button>
                
              </div>
              <div class="control">
                <router-link to="/dashboard" class="button is-medium">Back</router-link>
              </div>
              <div class="control">
                <button @click.prevent="deleteMeal"  class="button is-medium is-danger is-ouline">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

    
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import db from '../db'

export default {
  name: 'Home',
  components: {
    Datetime
  },
  data: function() {
    return {
      eatingTime: new Date().toISOString(),
      whatyouate: "",
      feelings: "",
      notes: "",
      hungerBefore: null,
      hungerAfter: null,
      saveBtnEnabled: false,
      saving: false,
      saved: false,
      id: null
    }
  },
  mounted: function () {
    this.id = this.$route.params.id;
    this.load();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    load: async function() {

      let meal = await db.getMeal(this.id)
      this.eatingTime = meal.eatingTime.toISOString()
      this.hungerBefore= meal.hungerBefore
      this.hungerAfter= meal.hungerAfter
      this.whatyouate= meal.whatyouate
      this.feelings= meal.feelings
      this.notes= meal.notes
    },
    deleteMeal: async function() {
      var r = confirm("Are you sure you want to delete this meal?");
      if (r == true) {
        await db.deleteMeal(this.id)
        this.$router.push({
          name: "Dashboard"
        });
      }
    },
    saveMeal: async function() {
      this.saving =true
      var meal = {
        eatingTime: new Date(this.eatingTime),
        hungerBefore: this.hungerBefore,
        hungerAfter: this.hungerAfter,
        whatyouate: this.whatyouate,
        feelings: this.feelings,
        notes: this.notes,
        saveBtnEnabled: false
      }
      console.log("save btn", meal)
      await db.updateMeal(meal)
      this.$router.push({
        name: "Dashboard"
      });
    }
  },
  watch: {
    hungerBefore: function (val) {
      this.saveBtnEnabled = val !== null && this.hungerAfter !== null
    },
    hungerAfter: function (val) {
      this.saveBtnEnabled = val !== null && this.hungerBefore !== null
    }
  }
}
</script>
